export default __webpack_public_path__ + "static/media/vertical-grey.d0591757.png";